import { UserRelatedShow } from "@/modules/users/components/Show"

const ExpertShow: React.FC = function () {
  return <UserRelatedShow>UserRelatedShow</UserRelatedShow>
}

export default ExpertShow
